// extracted by mini-css-extract-plugin
export var brand = "_1c-8";
export var compact = "_1c-5";
export var extraSmall = "_1c-6";
export var icon = "_1c-0";
export var large = "_1c-3";
export var light = "_1c-1";
export var medium = "_1c-4";
export var outline = "_1c-a";
export var primaryDark = "_1c-9";
export var primaryLight = "_1c-7";
export var primaryModern = "_1c-b";
export var success = "_1c-2";